"use client";

import { Input } from "../../../components/ui/input"
import { Textarea } from "../../../components/ui/textarea"
import { Checkbox } from "../../../components/ui/checkbox"
import { Label } from "../../../components/ui/label"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../../components/ui/select"
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandDialog } from "../../../components/ui/command"
import { Popover, PopoverContent, PopoverTrigger } from "../../../components/ui/popover"
import { Button } from "../../../components/ui/button"
import { AlertCircle, Upload } from "lucide-react"
import { useState } from "react"
import {  Form } from "react-bootstrap";
import ResourceComponent from "../../Components/ResourceLibrary/ResourceComponent"

import ReactSelect from "react-select";
import CustomSelect from "../CustomSelect";

import ReactDatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"



export function FormField({ field, value, onChange, error,students,onChangeWithKey,formData }) {
  const [open, setOpen] = useState(false)

  const renderField = () => {
    switch (field.inputType) {
      case "text":
        return (
          <Input
            type="text"
            placeholder={field.placeholder}
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            className={`bg-background border ${error ? "border-red-500" : "border-border"}`}
          />
        )

      case "number":
        return (
          <Input
            type="number"
            placeholder={field.placeholder}
            value={value || ""}
            onChange={(e) => onChange(e.target.value ? Number(e.target.value) : "")}
            min={field.props?.min}
            max={field.props?.max}
            className={`bg-background border ${error ? "border-red-500" : "border-border"}`}
          />
        )

      case "date":
        return (
          <ReactDatePicker
            selected={value ? new Date(value) : null}
            onChange={(date) => {
              if (!date) return
              
              const year = date.getFullYear()
              const month = String(date.getMonth() + 1).padStart(2, "0")
              const day = String(date.getDate()).padStart(2, "0")
              const formatted = `${year}-${month}-${day}`
              
              onChange(formatted)
            }}
            dateFormat="yyyy-MM-dd"
            placeholderText="Pick a date"
            className={`w-full bg-background border px-3 py-2 rounded-md text-sm ${
              error ? "border-red-500" : "border-border"
            }`}
            wrapperClassName="w-full"
          />
        )

      case "datetime":
        return (
          <ReactDatePicker
            selected={value ? new Date(value) : null}
            onChange={(date) => {
              if (!date) return
              
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, "0");
              const day = String(date.getDate()).padStart(2, "0");
              const hours = String(date.getHours()).padStart(2, "0");
              const minutes = String(date.getMinutes()).padStart(2, "0");
              const seconds = String(date.getSeconds()).padStart(2, "0");

              const formatted = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

              onChange(formatted);
            }}
            showTimeSelect
            timeIntervals={30}
            timeCaption="Time"
            dateFormat="yyyy-MM-dd HH:mm"
            placeholderText="Pick date & time"
            className={`w-full bg-background border px-3 py-2 rounded-md text-sm ${
              error ? "border-red-500" : "border-border"
            }`}
            wrapperClassName="w-full"
          />
        )

      case "textarea":
        return (
          <Textarea
            placeholder={field.placeholder}
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            className={`bg-background border resize-none ${error ? "border-red-500" : "border-border"}`}
            rows={4}
          />
        )

      case "boolean":
        return (
          <div className="flex items-center gap-3">
            <Checkbox checked={value || false} onCheckedChange={(checked) => onChange(checked)} className="w-5 h-5" />
            <span className="text-sm text-foreground">{field.label}</span>
          </div>
        )

      case "select":
        const selectOptions =
          field.options?.map((opt) => ({
            label: opt?.replaceAll("Gemini", "AI"),
            value: opt,
          })) || [];

        const isMulti = Boolean(field?.isMultiselect);

        return (
             <CustomSelect
                options={selectOptions}
                isMulti={isMulti}
                value={
                  isMulti
                    ? selectOptions.filter((opt) => (value || []).includes(opt.value))
                    : selectOptions.find((opt) => opt.value === value) || null
                }
                onChange={(opt) => {
                  if (isMulti) {
                    onChange(opt ? opt.map((o) => o.value) : []);
                  } else {
                    onChange(opt?.value ?? null);
                  }
                }}
                placeholder={field.placeholder || "Select an option..."}
                isClearable
              />
        )

      

      // case "file-uploader":
      //   return (
      //     <div
      //       className={`border-2 border-dashed rounded-lg p-6 text-center cursor-pointer transition-colors ${
      //         error ? "border-red-500 bg-red-50" : "border-border hover:border-primary bg-muted hover:bg-muted/80"
      //       }`}
      //     >
      //       <input
      //         type="file"
      //         onChange={(e) => onChange(e.target.files?.[0])}
      //         className="hidden"
      //         id={`file-${field.name}`}
      //       />
      //       <label htmlFor={`file-${field.name}`} className="cursor-pointer block">
      //         <Upload className="w-8 h-8 mx-auto mb-2 text-muted-foreground" />
      //         <p className="text-sm font-medium text-foreground">Click to upload</p>
      //         <p className="text-xs text-muted-foreground">{field.placeholder || "or drag and drop"}</p>
      //         {value && <p className="text-xs text-primary mt-2 font-medium">{value.name}</p>}
      //       </label>
      //     </div>
      //   )

      case "file-uploader":
        return formData["information_source"]=="Gemini only"?null:<ResourceComponent
              resourceType={field.resourceType} // rag,nonRag,all
              selectedResources={value ?? []}
              onSelectResources={(resources) => {
                onChange(resources);
              }}
            />;

      case "file-uploader-with-source-selector":
        const uploaderOptions = [
          { label: "Use Gemini only", value: "use_gemini_only" },
          { label: "Use Selected Resource Only", value: "use_selected_resource_only" },
          { label: "Use Gemini & Selected Resource", value: "use_gemini_and_resource" },
        ]

        return (
          <div className="flex flex-col gap-3">
            {/* Show Resource Source Select if enabled */}
            {field.showResourceSourceOptions && (
              <div className="w-full">
                <Form.Label className="bootstrap-label mb-1">
                  Resource Source
                </Form.Label>

                 <CustomSelect
                  options={uploaderOptions}
                    value={
                      uploaderOptions?.find(
                        (opt) => opt.value === formData[field.name+"_resourceSourceValue"]
                      ) || { label: "Use Gemini only", value: "use_gemini_only" }
                    }
                    onChange={(opt) =>{
                      var changeKey = field.name+"_resourceSourceValue"
                      onChangeWithKey(changeKey,opt.value )
                    }}
                    placeholder="Select resource source..."
              />
              </div>
            )}

            {/* Show ResourceComponent if select is not 'None' */}
            {(!field.showResourceSourceOptions ||
               ( field.showResourceSourceOptions && formData[field.name+"_resourceSourceValue"] != null && formData[field.name+"_resourceSourceValue"] != "none")) && (
              <div
                className={`border-2 border-dashed rounded-lg p-6 text-center cursor-pointer transition-colors ${
                  error
                    ? "border-red-500 bg-red-50"
                    : "border-border hover:border-primary bg-muted hover:bg-muted/80"
                }`}
              >
                <ResourceComponent
                  resourceType={field.resourceType} // rag, nonRag, all
                  selectedResources={value ?? []}
                  onSelectResources={(resources) => {
                    onChange(resources);
                  }}
                />
              </div>
            )}
          </div>
        )


      case "student-list":
        const options = students?.map(o => ({
            value: o.id,
            label: o.name
        }))

        if (
          options.length &&
          (value === undefined || value === "")
        ) {
          console.log("init student list");
          onChange(options.map(o => o.value));
        }

        return (
             <CustomSelect
                isMulti
                options={options}
                value={options?.filter(o => value?.includes(o.value))}
                onChange={(vals) => onChange(vals.map(v => v.value))}
                placeholder="Select students..."
              />
        )

      default:
        return null
    }
  }

  return (
    <div className="space-y-2">
      {(field.inputType !== "boolean" && !(formData["information_source"]=="Gemini only" && field.inputType === "file-uploader")) && (
        <div className="flex items-start justify-between gap-2">
          <div>
            <Label className="text-base font-semibold text-foreground">
              {field.label}
              {field.required && <span className="text-red-500 ml-1">*</span>}
            </Label>
            {field.description && <p className="text-xs text-muted-foreground mt-1">{field.description}</p>}
          </div>
        </div>
      )}

      {renderField()}

      {error && (
        <div className="flex items-center gap-2 text-red-500 text-sm">
          <AlertCircle className="w-4 h-4" />
          {error}
        </div>
      )}
    </div>
  )
}
